import React from 'react';
import classNames from 'classnames';

import styles from './Status.module.scss';

interface Props {
	className?: string;
	isBillable: null | boolean;
}
const BillableStatus: React.FC<Props> = props => {
	const { isBillable, className } = props;
	return (
		<div>
			<div>Closed by SP as</div>
		<div
			className={classNames(className, {
				[styles.statusBillable]: isBillable,
				[styles.statusNonBillable]: !isBillable,
			})}
		>
			{isBillable ? 'billable' : 'non-billable'}
		</div>
		</div>
	);
};

export default BillableStatus;
